import { ComponentPropsWithoutRef, FC } from 'react';

type OpenInNewIconProps = ComponentPropsWithoutRef<'svg'>;

export const OpenInNewIcon: FC<OpenInNewIconProps> = ({ fill, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
        >
            <path
                d="M2.7548 14.5817C2.37966 14.5817 2.06258 14.4521 1.80355 14.1931C1.54452 13.9341 1.41501 13.617 1.41501 13.2419V2.75478C1.41501 2.37965 1.54452 2.06256 1.80355 1.80354C2.06258 1.54451 2.37966 1.41499 2.7548 1.41499H7.67772V2.49833H2.7548C2.69063 2.49833 2.63188 2.52506 2.57855 2.57853C2.52508 2.63187 2.49834 2.69062 2.49834 2.75478V13.2419C2.49834 13.306 2.52508 13.3648 2.57855 13.4181C2.63188 13.4716 2.69063 13.4983 2.7548 13.4983H13.2419C13.3061 13.4983 13.3648 13.4716 13.4181 13.4181C13.4716 13.3648 13.4983 13.306 13.4983 13.2419V8.31895H14.5817V13.2419C14.5817 13.617 14.4522 13.9341 14.1931 14.1931C13.9341 14.4521 13.617 14.5817 13.2419 14.5817H2.7548ZM6.07688 10.6937L5.30293 9.91979L12.7244 2.49833H9.99834V1.41499H14.5817V5.99833H13.4983V3.27229L6.07688 10.6937Z"
                fill={fill ?? 'currentColor'}
            />
        </svg>
    );
};
